import { FC } from "react";
import { Victim } from "types";
import { DateView } from "utils/helper";

type Props = {
  victim: Victim | undefined;
  isOpen: boolean;
  onClose: () => void;
};

const VictimPersonalDetail: FC<Props> = ({ victim, isOpen, onClose }) => {
  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <div className="text-base font-semibold text-white bg-[#212121] p-3 inline-block rounded-md">
          Victim ID &nbsp;&nbsp; : &nbsp;&nbsp;
          {victim?.identity_card_number}
        </div>

        <br />

        <div className="flex flex-row gap-4 mt-3 items-start">
          <div className="bg-[#BCBCBC66] rounded-md">
            <img
              src={
                victim?.picture_file ||
                require("../../../../images/imageVector.png")
              }
              alt="User"
              className="w-auto h-[110px] rounded"
            />
          </div>
          <div className="flex flex-col w-[250px]">
            <div className="bg-[#9B0505] w-fit px-2 py-[2px] text-white rounded-md text-center font-medium text-sm">
              {typeof victim?.investigation === "object" &&
                victim?.investigation?.CR_number}
            </div>
            <h2 className="text-[22px] font-semibold leading-7">
              {victim?.first_name} {victim?.middle_name} {victim?.last_name}
            </h2>
            <p className="text-base font-normal text-[#8B8B8B]">
              {victim?.phone_number}
            </p>
            <p className="text-base font-normal text-[#8B8B8B]">
              {victim?.email}
            </p>
          </div>
        </div>

        {[
          { property: "Gender", value: victim?.gender },
          { property: "Age", value: victim?.age },
          { property: "Educational Level", value: victim?.education_level },
          { property: "Job position", value: victim?.job_position },
          { property: "Ethnicity", value: victim?.ethnicity },
          { property: "Nationality", value: victim?.nationality },
          { property: "Religion", value: victim?.religion },
          {
            property: "Date of Birth",
            value: DateView(victim?.date_of_birth),
          },
          { property: "Phone Number", value: victim?.phone_number },
          { property: "Email", value: victim?.email },
          {
            property: "Identity Card Number",
            value: victim?.identity_card_number,
          },
          { property: "Injury Details", value: victim?.injury_details },
          { property: "Statement", value: victim?.statement },
        ]?.map((info, index) => (
          <div
            key={index}
            className="flex flex-row gap-4 mt-3 items-start justify-between border-b border-b-[#E9E9E9] pb-3"
          >
            <p className="font-normal text-base text-[#0A1D39]">
              {info?.property}
            </p>
            <p className="font-normal text-base text-[#0A1D39]">
              {typeof info?.value === "boolean" ||
              typeof info?.value === "object"
                ? info?.value ?? "-"
                : info?.value}
            </p>
          </div>
        ))}

        <div className="bg-[#F8F8F8] p-3 rounded-xl mt-5">
          <p className="text-base font-semibold">Address Location</p>
          <hr className="text-[#8B8B8B] my-3 w-[50%]" />

          <div className="grid grid-cols-2 gap-2 gap-x-4 mt-4">
            {[
              { property: "Region", value: victim?.region },
              { property: "Zone", value: victim?.zone },
              { property: "Woreda", value: victim?.woreda },
              { property: "Kebele", value: victim?.kebele },
              { property: "House_number", value: victim?.house_number },
              { property: "City", value: victim?.city },
            ]?.map((info, index) => (
              <div key={index}>
                <p className="font-normal text-sm text-[#747171]">
                  {info.property}
                </p>
                <p className="font-semibold text-base text-[#0A1D39]">
                  {info.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VictimPersonalDetail;
